<template>
  <div>
    <page-header
      :has-add="HasCreateTablePermission"
      add-text="Crear Tabla"
      :page="page"
      :has-return="true"
      @onAdd="goToSampleTable"
      @onReturn="() => $router.push({ path: '/student' })"
    >
      <template #custom_actions>
        <div v-if="results.length > 0" class="d-inline">
          <DropDown
            class="mr-3 dd"
            :title="{
              name: 'Informes',
              icon: 'file-export',
              color: 'text-green',
            }"
            :items="dropDown.reportDD"
            @summary="goToDownloadInventorySurveySummaryReport"
          />
        </div>
      </template>
    </page-header>

    <FilterManager
      :filters-header="filtersHeader"
      :filters-content="filtersContent"
      :disable-button="disableButton"
      @search="performSearch"
      @status="updateFiltersData('selectedStatus', $event)"
      @year="changeYear"
      @regions="updateFiltersData('selectedRegion', $event, 'loadDistricts')"
      @districts="updateFiltersData('selectedDistrict', $event, 'loadSchools')"
      @schools="updateFiltersData('selectedSchool', $event)"
    />
    <br />
    <br />

    <div class="col-12">
      <div class="custom-separator-title">
        <CustomSeparator :text="page.separator" />
      </div>
    </div>

    <!--dashboard-->
    <div v-if="results.length > 0" class="d-flex flex m-4">
      <div
        v-if="HasYearTableViewPermission"
        class="board btn__academic--defined"
      >
        <div class="w-75 w-rp-100">
          <action-button
            class="w-100 mt-1"
            variant="outline-success"
            :text="`Ver tabla de muestra ${academicYearName}`"
            @click="goToSampleTable(true)"
          />
        </div>
      </div>
      <div
        v-for="data in this.counters"
        :key="data.key"
        class="board ml-3 b-33"
      >
        <span class="font-weight-normal">{{ data.key }}</span>
        <p>{{ data.value }}</p>
      </div>
      <div class="board container-circle row">
        <div class="mr-3">
          <span class="font-weight-normal">Porciento</span>
          <p class="font-weight-normal">
            Completado
          </p>
        </div>
        <div class="mt-n3">
          <div class="w-circle">
            <circle-loader :percentage="circleValue" />
          </div>
        </div>
      </div>
    </div>

    <!--Items-->
    <div v-if="results.length > 0">
      <custom-callout
        v-for="(item, id) in results"
        :key="id"
        class="mb-4"
        :show-edition="item.isOpen"
        :border-color="`border__left--${getColorStatus(item.statusName)}`"
      >
        <div class="d-flex flex-item">
          <div class="board w-fixed">
            <div>
              <span
                :class="`bg--${getColorStatus(item.statusName)}`"
                class="badge bag"
              >
                {{ item.statusName }}
              </span>
              <br />
              <br />
              <div v-if="item.statusName !== 'Nuevo'">
                <span class="font-weight-normal">Fecha:</span>
                <p>{{ $formatDate(item.statusDate) }}</p>
              </div>
            </div>
            <div />
          </div>
          <div class="board w-fixed border-left sie-content pl-3">
            <div>
              <span class="font-weight-normal">SIE:</span>
              <p>{{ item.sie }}</p>
            </div>
            <div>
              <span class="font-weight-normal">Regi&oacute;n:</span>
              <p>{{ item.regionName }}</p>
            </div>
          </div>
          <div class="board w-fixed name-content">
            <div>
              <span class="font-weight-normal">Nombre:</span>
              <p>{{ item.studentName }}</p>
            </div>
            <div>
              <span class="font-weight-normal">Distrito:</span>
              <p>{{ item.districtName }}</p>
            </div>
          </div>
          <div class="board w-fixed media-content">
            <div>
              <span class="font-weight-normal">Medio:</span>
              <p>
                {{
                  notificationWayDesc(item.statusID, item.notificationWayName)
                }}
              </p>
            </div>
            <div>
              <span class="font-weight-normal">Escuela:</span>
              <p>{{ item.schoolName }}</p>
            </div>
          </div>
          <div class="board w-fixed">
            <DropDown
              v-if="hasActions(item)"
              ref="actionContentOption"
              class="d-flex justify-content-end mt-5 pr-2 no-margin-top"
              :items="getActionItems(item)"
              @printLetter="printLetter(item)"
              @changeStatusNew="setStatus($event, item)"
              @changeStatusNotified="setStatus($event, item)"
              @changeStatusCanceled="setStatus($event, item)"
            />
          </div>
        </div>
        <ParentInventoryActionContent
          slot="edition"
          :inventory-status="inventoryStatus"
          :item="item"
          @saveInventoryStatus="saveStatus($event)"
          @cancelInventoryStatus="cancelStatus($event, item)"
        />
      </custom-callout>
      <Pagination
        id="pgParentInventory"
        :data="pagination"
        @pagination-go-page="goToPage"
      />
    </div>

    <div
      v-if="results.length === 0"
      class="col-12 p-4 text-center align-items-center no-info mt-4"
    >
      <div class="row justify-content-center">
        <div class="col-12 col-lg-1 align-self-center">
          <i class="far fa-folder-open icon no-info-icon pl-2" />
        </div>
        <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
          <span class="no-info-text">No hay información disponible.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterManager from '@/components/common/FilterCustomManager';
import PageHeader from '@/components/common/page/PageHeader';
import CustomSeparator from '@/components/common/CustomSeparator';
import DropDown from '@/components/common/menu/DropDown';
import ActionButton from '@/components/common/ActionButton';
import Pagination from 'pagination';
import CircleLoader from '@/components/common/loaders/CircleLoader.vue';
import CustomCallout from '@/components/common/CustomCallout.vue';
import generalService from '@/services/pei/general';
import ParentInventoryActionContent from '@/views/student/ParentInventory/components/ParentInventoryActionContent.vue';
import ParentInventoryStatus from '@/utils/constants/student/parentInventoryStatus';
import mixAlert from '@/mixin/alert.mixin';
import studentService from '@/services/student';
import { createNamespacedHelpers } from 'vuex';
const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers(
  'parentInventory'
);

export default {
  name: 'ParentInventory',
  mixins: [mixAlert],
  components: {
    FilterManager,
    PageHeader,
    CustomSeparator,
    DropDown,
    ActionButton,
    Pagination,
    CircleLoader,
    CustomCallout,
    ParentInventoryActionContent,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Inventario de Padres',
        routes: ['Inicio', 'Estudiante', 'Inventario de Padres'],
        separator:
          'Inventario para Padres de Estudiantes que Reciben Servicios de Educación Especial',
      },
      moduleName: 'parentInventory',
      inventoryStatus: null,
      dropDown: {
        reportDD: [
          {
            Title: 'Resumen de Contestaciones',
            Icon: 'fas fa-print',
            IconColor: 'text-green',
            Type: 'Menu',
            EmitGo: 'summary',
            Children: [],
          },
        ],
      },
    };
  },
  methods: {
    getActionItems(item) {
      let items = [
        {
          Title: `Imprimir Carta de Notificación`,
          Icon: 'fas fa-print',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'printLetter',
          Children: [],
          Visible: this.canPrintLetter(),
        },
        {
          Title: 'Cambiar a Nuevo',
          Icon: 'fas fa-flag',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'changeStatusNew',
          Children: [],
          Visible: this.canChangeStatusNew(item),
          Item: { Status: ParentInventoryStatus.New },
        },
        {
          Title: 'Cambiar a Notificado',
          Icon: 'fas fa-flag',
          IconColor: 'text-green',
          Type: 'Menu',
          EmitGo: 'changeStatusNotified',
          Children: [],
          Visible: this.canChangeStatusNotified(item),
          Item: { Status: ParentInventoryStatus.Notified },
        },
        {
          Title: 'Cancelar',
          Icon: 'fas fa-times-circle',
          IconColor: 'text-red',
          Type: 'Menu',
          EmitGo: 'changeStatusCanceled',
          Children: [],
          Visible: this.canChangeStatusCaceled(item),
          Item: { Status: ParentInventoryStatus.Canceled },
        },
      ];
      return items;
    },
    ...mapMutations(['setCanResearch', 'setValue', 'reset']),
    ...mapActions([
      'loadMountedData',
      'loadRegions',
      'loadDistricts',
      'loadSchools',
      'loadResults',
    ]),
    async performSearch() {
      this.pagination.currentPage = 1;
      await this.search();
    },
    verifyRoleAccess(roles) {
      let roleAccess = false;
      const userRole = this.userRole;
      if (roles === undefined) {
        roleAccess = true;
      }

      if (roles) {
        roleAccess = roles.find((x) => x == userRole) ? true : false;
      }
      return roleAccess;
    },
    goToSampleTable(withParams = false) {
      let route = {
        name: 'SampleTable',
        params: { fiscalYearId: this.selectedAcademicYearId },
      };

      if (!withParams) {
        delete route.params;
      }
      this.setCanResearch(false);
      this.$router.push(route);
    },
    changeYear(event) {
      this.updateFiltersData('selectedAcademicYear', event, 'loadRegions');
      this.reset(['selectedAcademicYear']);
    },
    async goToDownloadInventorySurveySummaryReport() {
      let academicYear = this.$store.state.parentInventory.selectedAcademicYear
        .id;
      studentService.downloadInventorySurveySummaryReport(academicYear);
    },
    async goToPage(page) {
      this.pagination.currentPage = page;

      await this.search();
    },
    updateFiltersData(key, data, callDispatch) {
      this.setValue({
        property: key,
        data,
      });

      if (callDispatch != undefined) {
        if (typeof this[callDispatch] == 'function') {
          this[callDispatch]();
        }
      }
    },
    async search() {
      let filter = this.parentInventory;

      let filterProperties = {
        AcademicYearId: filter.selectedAcademicYear
          ? filter.selectedAcademicYear.id
          : null,
        StatusId:
          filter.selectedStatus && filter.selectedStatus.id !== -1
            ? filter.selectedStatus.id
            : null,
        RegionId: filter.selectedRegion ? filter.selectedRegion.id : null,
        DistrictId: filter.selectedDistrict ? filter.selectedDistrict.id : null,
        LocationSchoolId: filter.selectedSchool
          ? filter.selectedSchool.id
          : null,
        PageIndex: this.pagination.currentPage,
        PageSize: this.pagination.pageSize,
      };

      this.loadResults(filterProperties);
    },
    getColorStatus(status) {
      let color = null;

      switch (status) {
        case 'Nuevo':
        case 'Notificado':
          color = 'yellow';
          break;
        case 'Completado':
          color = 'green';
          break;
        case 'Cancelado':
          color = 'purple';
          break;
      }

      return color;
    },
    async printLetter(item) {
      let studentInfo = `${item.sie} - ${item.studentName}`;

      this.$ApiGet(
        `/api/parentInventory/certificacionLetterReport/${studentInfo}`
      )
        .then((res) => {
          generalService.documentDownloadReport(
            res.data.content,
            res.data.filename
          );
        })
        .catch((err) => {
          this.response = err.data.message;
        });
    },
    setStatus(event, item) {
      this.inventoryStatus = event.Status;
      item.isOpen = true;
      this.$forceUpdate();
    },
    async saveStatus(data) {
      this.$ApiPost('api/parentInventory/updateSampleInventoryDetail', data)
        .then(() => {
          this.search();
          this.ShowToast(
            'Actualizado',
            'Su estatus ha sido cambiado exitosamente',
            'success'
          );
        })
        .catch((err) => {
          this.ShowToast(err.message, '', 'error');
        });
    },
    async cancelStatus(data, item) {
      item.isOpen = false;
      this.$forceUpdate();
    },
    getStatusName(status) {
      switch (status) {
        case ParentInventoryStatus.New:
          return 'Nuevo';
        case ParentInventoryStatus.Notified:
          return 'Notificado';
        case ParentInventoryStatus.Completed:
          return 'Completado';
        case ParentInventoryStatus.Canceled:
          return 'Cancelado';
      }
    },
    canChangeStatusNew(item) {
      return (
        item.statusID === ParentInventoryStatus.Completed &&
        this.$store.getters.HasPermission('parentInventory.changeStatusNew')
      );
    },
    canChangeStatusNotified(item) {
      return (
        item.statusID === ParentInventoryStatus.New &&
        this.$store.getters.HasPermission(
          'parentInventory.changeStatusNotified'
        )
      );
    },
    canChangeStatusCaceled(item) {
      return (
        (item.statusID === ParentInventoryStatus.New ||
          item.statusID === ParentInventoryStatus.Notified) &&
        this.$store.getters.HasPermission(
          'parentInventory.changeStatusCanceled'
        )
      );
    },
    canPrintLetter() {
      return this.$store.getters.HasPermission(
        'parentInventory.printNotificationLetter'
      );
    },
    hasActions(item) {
      let hasActions =
        this.canChangeStatusNew(item) ||
        this.canChangeStatusNotified(item) ||
        this.canChangeStatusCaceled(item) ||
        this.canPrintLetter();

      return hasActions;
    },
  },
  computed: {
    filtersHeader() {
      return [
        {
          name: 'year',
          component: 'CustomDropDown',
          placeholder: 'Seleccione Año',
          value: this.parentInventory.selectedAcademicYear,
          options: this.parentInventory.academicYears,
          fieldName: 'description',
          fieldKey: 'id',
          grow: 1,
          class: 'col-12 col-md-4 col-lg-3 py-1',
          validations: 'required',
          error:
            'El campo Año Fiscal es obligatorio para realizar la búsqueda.',
          clearable: false,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          placeholder: 'Seleccione estatus',
          value: this.parentInventory.selectedStatus,
          options: this.parentInventory.sampleInventoryStatuses,
          fieldName: 'name',
          fieldKey: 'id',
          grow: 2,
          class: 'col-12 col-md-4 col-lg-6 col-xl-7 py-1',
        },
      ];
    },
    filtersContent() {
      return [
        {
          name: 'regions',
          component: 'CustomDropDown',
          placeholder: 'Region',
          options: this.parentInventory.regions,
          value: this.parentInventory.selectedRegion,
          fieldName: 'name',
          fieldKey: 'id',
        },
        {
          name: 'districts',
          component: 'CustomDropDown',
          placeholder: 'Distrito',
          options: this.parentInventory.districts,
          value: this.parentInventory.selectedDistrict,
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.parentInventory.selectedDistrict == null,
          disabled: this.parentInventory.selectedRegion == null,
        },
        {
          name: 'schools',
          component: 'CustomDropDown',
          placeholder: 'Escuela',
          options: this.parentInventory.schools,
          value: this.parentInventory.selectedSchool,
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.parentInventory.selectedSchool == null,
          disabled: this.parentInventory.selectedDistrict == null,
        },
      ];
    },
    disableButton() {
      return this.parentInventory.selectedAcademicYear == null;
    },
    notificationWayDesc() {
      return (statusId, notificationWayDesc) =>
        [ParentInventoryStatus.New].includes(statusId)
          ? '-'
          : notificationWayDesc;
    },
    HasCreateTablePermission() {
      return this.$store.getters.HasPermission('parentinventory.tablecreate');
    },
    HasYearTableViewPermission() {
      return this.$store.getters.HasPermission('parentinventory.yeartableview');
    },
    ...mapGetters([
      'parentInventory',
      'circleValue',
      'counters',
      'results',
      'pagination',
      'academicYearName',
      'selectedAcademicYearId',
    ]),
  },
  mounted() {
    this.loadMountedData();
  },
  watch: {
    'parentInventory.selectedRegion': function() {
      this.setValue({
        property: 'selectedDistrict',
        data: null,
      });
    },
    'parentInventory.selectedDistrict': function() {
      this.setValue({
        property: 'selectedSchool',
        data: null,
      });
    },
  },
};
</script>

<style scoped>
.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}

.board {
  flex-grow: 3;
}

.board.w-fixed {
  flex-basis: 55em;
  margin-right: 25px;
}

.bag {
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 10px 30px;
}

.w-circle {
  width: 75px;
}

@media screen and (max-width: 815px) {
  .b-33 {
    flex: 25%;
  }
}

@media screen and (max-width: 547px) {
  .container-circle {
    margin-left: 3%;
  }
}

@media screen and (max-width: 1189px) {
  .sie-content,
  .name-content {
    margin-right: 5%;
  }
}

@media screen and (max-width: 1142px) {
  .flex {
    flex-wrap: wrap;
  }

  .btn__academic--defined {
    flex: 100% !important;
    margin-bottom: 2%;
  }

  .w-rp-100 {
    width: 100% !important;
  }
}

@media screen and (max-width: 1507px) {
  .btn__academic--defined {
    position: relative;
    bottom: 10px;
  }
}

@media screen and (max-width: 650px) {
  .board.w-fixed {
    flex-basis: 0;
    margin-right: 25px;
  }

  .flex-item {
    flex-direction: column;
  }

  .sie-content {
    border-left: none !important;
    padding: 0 !important;
  }

  .no-margin-top {
    margin-top: 0 !important;
    justify-content: initial !important;
  }
}

@media screen and (max-width: 850px) {
  .bag {
    border-radius: 18px;
    opacity: 1;
    text-align: center;
    font: Bold 16px/21px Lato;
    letter-spacing: 0;
    color: #11291b;
    padding: 10px 30px;
  }

  .dropInform {
    width: 300px;
    height: 40px;
    padding-left: 10px;
  }

  @media screen and (max-width: 855px) {
    .dd {
      margin: 0 !important;
      margin-bottom: 1% !important;
    }
  }
}
</style>
